module.exports = __webpack_public_path__ + "static/img/yyfhh.97a2b6e7.gif";